import IntegrationsPage from '@/modules/integrations/pages/IntegrationsPage'
import IntegrationsList from '@/modules/integrations/pages/IntegrationsList'
import IntegrationsMarketplace from '@/modules/integrations/pages/IntegrationsMarketplace'
import IntegrationCreatePage from '@/modules/integrations/pages/IntegrationCreatePage'
import IntegrationCreateSteppedPage from '@/modules/integrations/pages/IntegrationCreateSteppedPage'
import IntegrationPage from '@/modules/integrations/pages/IntegrationPage'
import IntegrationOverview from '@/modules/integrations/pages/IntegrationOverview'
import IntegrationSettings from '@/modules/integrations/pages/IntegrationSettings'
import IntegrationPromotions from '@/modules/integrations/pages/IntegrationPromotions'
import IntegrationCouponsets from '@/modules/integrations/pages/IntegrationCouponsets'
import IntegrationTasks from '@/modules/integrations/pages/IntegrationTasks'
import IntegrationHistory from '@/modules/integrations/pages/IntegrationHistory'
import IntegrationTestTool from '@/modules/integrations/pages/IntegrationTestTool.vue'
import Integrations from '@/modules/integrations/types'

export default [
  {
    name: 'Integrations',
    path: '/integrations',
    component: IntegrationsPage,
    meta: { auth: ['viewProjectTechnical'] },
    children: [
      {
        name: 'IntegrationsList',
        path: 'index',
        component: IntegrationsList,
        meta: { auth: ['viewProjectTechnical'] }
      },
      {
        name: 'IntegrationsMarketplace',
        path: 'marketplace',
        component: IntegrationsMarketplace,
        meta: { auth: ['viewProjectTechnical'] }
      }
    ]
  },

  {
    name: 'IntegrationCreate',
    path: '/integration/create',
    component: IntegrationCreatePage,
    beforeEnter: (to, from, next) => {
      let integrationType = Integrations[to.query.type]
      if (integrationType === undefined) {
        integrationType = Integrations['dynamicpromotions']
      }
      if (integrationType.stepped) {
        next({
          name: 'IntegrationSteppedCreate',
          query: to.query
        })
      } else {
        next()
      }
    },
    meta: { auth: ['manageProjectTechnical'] }
  },

  {
    name: 'IntegrationSteppedCreate',
    path: '/integration/create',
    component: IntegrationCreateSteppedPage,
    meta: { auth: ['manageProjectTechnical'] }
  },

  {
    name: 'Integration',
    path: '/integration',
    component: IntegrationPage,
    meta: { auth: ['viewProjectTechnical'] },
    children: [
      {
        name: 'IntegrationOverview',
        path: 'overview',
        component: IntegrationOverview,
        meta: { auth: ['viewProjectTechnical'] }
      },
      {
        name: 'IntegrationSettings',
        path: 'settings',
        component: IntegrationSettings,
        meta: { auth: ['viewProjectTechnical'] }
      },
      {
        name: 'IntegrationPromotions',
        path: 'promotions',
        component: IntegrationPromotions,
        meta: { auth: ['viewProjectTechnical'] }
      },
      {
        name: 'IntegrationCouponsets',
        path: 'couponsets',
        component: IntegrationCouponsets,
        meta: { auth: ['viewProjectTechnical'] }
      },
      {
        name: 'IntegrationTasks',
        path: 'tasks',
        component: IntegrationTasks,
        meta: { auth: ['viewProjectTechnical'] }
      },
      {
        name: 'IntegrationHistory',
        path: 'history',
        component: IntegrationHistory,
        meta: { auth: ['viewProjectTechnical'] }
      },
      {
        name: 'IntegrationTestTool',
        path: 'test-tool',
        component: IntegrationTestTool,
        meta: { auth: ['viewProjectTechnical'] }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/integrations/router/index.js